import { render, staticRenderFns } from "./MyDialog.vue?vue&type=template&id=e81f2912&scoped=true"
import script from "./MyDialog.vue?vue&type=script&lang=js"
export * from "./MyDialog.vue?vue&type=script&lang=js"
import style0 from "./MyDialog.vue?vue&type=style&index=0&id=e81f2912&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81f2912",
  null
  
)

export default component.exports